module.exports = __webpack_public_path__ + "static/media/silence_400s.702ba50f.mp3";